module.exports = __webpack_public_path__ + "static/media/Arch--yellow.31f6c8dc.svg";